module.exports = __webpack_public_path__ + "img/tomato7Headkit.4570c6b1.jpg";